import numeral from 'numeral';

if (numeral.locales['user-locale'] === undefined) {
  numeral.register('locale', 'id-idr', {
    delimiters: {
      thousands: '.',
      decimal: ',',
    },
    abbreviations: {
      thousand: 'Rb',
      million: 'Jt',
      billion: 'Mil',
      trillion: 'T',
    },
    ordinal(number) {
      return '' + number;
    },
    currency: {
      symbol: 'Rp ',
    },
  });

  // load a locale
  numeral.register('locale', 'en-idr', {
    delimiters: {
      thousands: ',',
      decimal: '.',
    },
    abbreviations: {
      thousand: 'K',
      million: 'M',
      billion: 'B',
      trillion: 'T',
    },
    ordinal(number) {
      return '' + number;
    },
    currency: {
      symbol: 'IDR ',
    },
  });
}

export default numeral;
